import type { PopupProps } from 'vant'
import Popup from 'vant/lib/popup'
import router from '@/router'
import i18n from '@/i18n'

// @ts-ignore
export default function showPopup(
  comp: Component,
  props: (Partial<PopupProps> & { class?: string; style?: any }) | null = {},
  componentProps: any = {},
) {
  const rootEl = document.createElement('div')
  rootEl.classList.add('fitCenter')
  document.body.appendChild(rootEl)

  const app = createApp({
    setup() {
      // bugfix: 热更新在某些情况下使得afterEach立刻执行，导致组件立刻被卸载
      let removeGuard
      setTimeout(() => {
        removeGuard = router.afterEach(() => {
          unmount()
        })
      })

      const unmount = () => {
        removeGuard?.()
        app.unmount()
        rootEl.remove()
      }

      const show = ref(false)
      onMounted(() => {
        show.value = true
      })

      const close = () => {
        show.value = false

        setTimeout(() => {
          document.body.classList.remove('van-overflow-hidden')
        }, 100)
      }

      provide('close', close)

      return () => (
        <Popup
          duration="0.2"
          closeOnClickOverlay={props?.closeOnClickOverlay}
          {...props}
          show={show.value}
          onClickCloseIcon={close}
          onClosed={unmount}
          onClose={close}
        >
          <comp close={close} {...componentProps} />
        </Popup>
      )
    },
  })

  app.use(router)
  app.use(i18n)
  app.mount(rootEl)
}
